export default __webpack_public_path__ + "static/media/pic102.5982af1c.jpg";